import superagent from 'superagent'
import PlayFab, { registerUser, login, checkPlayerToken } from '@/Agent/PlayFab'
import IntroScreen from '@/Agent/IntroScreen'
import PrePick from '@/Agent/PrePick'
import Auth from '@/Agent/Auth'
import * as GameServer from '@/Agent/GameServer'
import ImportAgent from '@/Agent/ImportAgent'
import * as Server from '@/Agent/Server'

export default {
  Auth: Auth(PlayFab),
  PlayFab,
  IntroScreen,
  PrePick,
  registerUser,
  login,
  checkPlayerToken,
  GameServer,
  Server,
  ImportAgent,
}



// WEBPACK FOOTER //
// src/Agent/index.js